module.exports = __webpack_public_path__ + "static/media/drop-down-p.055d8b0f.svg";